(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './lang', './env'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./lang'), require('./env'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.lang, global.env);
    global.unit = mod.exports;
  }
})(this, function (exports, _lang, _env) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.addUnit = addUnit;
  exports.unitToPx = unitToPx;
  // import { isDef, inBrowser } from './index'
  function isNumeric(val) {
    return (/^\d+(\.\d+)?$/.test(val)
    );
  }

  function addUnit(value) {
    if (!(0, _lang.isDef)(value)) {
      return undefined;
    }
    value = String(value);
    return isNumeric(value) ? value + 'px' : value;
  }
  // cache
  var rootFontSize = void 0;

  function getRootFontSize() {
    if (!rootFontSize) {
      var doc = document.documentElement;
      var fontSize = doc.style.fontSize || window.getComputedStyle(doc).fontSize;
      rootFontSize = parseFloat(fontSize);
    }
    return rootFontSize;
  }

  function convertRem(value) {
    value = value.replace(/rem/g, '');
    return +value * getRootFontSize();
  }

  function convertVw(value) {
    value = value.replace(/vw/g, '');
    return +value * window.innerWidth / 100;
  }
  function unitToPx(value) {
    if (typeof value === 'number') {
      return value;
    }
    if (_env.inBrowser) {
      if (value.indexOf('rem') !== -1) {
        return convertRem(value);
      }
      if (value.indexOf('vw') !== -1) {
        return convertVw(value);
      }
    }
    return parseFloat(value);
  }
});